import React from 'react';

const ContactButtons = () => {
  return (
    <div 
      className="contact-buttons" 
      style={{
        position: 'fixed', 
        bottom: '20px', 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'space-between', 
        padding: '0 20px', 
        zIndex: 1000,
        pointerEvents: 'none', 
      }}
    >
      
      <a 
        href="https://wa.me/919075462128?text=Hello%20Meghana%20Cabs,%20I%20am%20interested%20in%20booking%20a%20cab.%20Could%20you%20please%20share%20more%20details%20at%20your%20earliest?%20Thank%20you!"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#25D366', 
          border: '1px solid white',
          borderRadius: '50%', 
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001,
          pointerEvents: 'auto', 
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1DAE3E')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#25D366')}
      >
        <img src="/images/whatsapp.png" alt="WhatsApp" style={{ width: '30px', height: '30px' }} />
      </a>

      <a 
        href="tel:+919075462128" 
        className="call-button" 
        style={{
          backgroundColor: '#FF614A', 
          borderRadius: '50%',
          border: '1px solid white',
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001, 
          pointerEvents: 'auto',
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#FF614A')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#FF614A')}
      >
        <img src="/images/Phone.png" alt="Call" style={{ width: '30px', height: '30px' }} />
      </a>

     

    </div>
  );
};

export default ContactButtons;